module.exports = __webpack_public_path__ + "static/media/emotion-slow.a16bf1b9.mp3";